import React from 'react';
import PropTypes from 'prop-types';
import { Button, Stack, Card, Form } from "@curves/ui-base";

const OverviewListSearchBar = ({ className, children, onSubmit, isResetEnabled = false, isDownloadEnabled = false, ...rest }) => {
    return (
        <Card className={className} {...rest}>
            <Card.CardContent className={'p-3'}>
                <Form onSubmit={onSubmit}>
                    <React.Fragment>{children}</React.Fragment>
                    <Stack className={'mt-2'} justifyContent={'end'} spacing={2}>
                        <Button type={'submit'} variant={'contained'}>
                            搜尋
                        </Button>
                    </Stack>
                </Form>
            </Card.CardContent>
        </Card>
    );
};

OverviewListSearchBar.prototype = {
    className: PropTypes.string,
    children: PropTypes.node,
    onSubmit: PropTypes.func,
    isResetEnabled: PropTypes.bool,
    isDownloadEnabled: PropTypes.bool,
};

export default OverviewListSearchBar;
